import { render, staticRenderFns } from "./select-cms-item.vue?vue&type=template&id=3b7cae7f&scoped=true"
import script from "./select-cms-item.vue?vue&type=script&lang=js"
export * from "./select-cms-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7cae7f",
  null
  
)

export default component.exports